import { useEffect, useMemo, useState } from 'react';
import Modal, { ModalActionData } from '../components/Common/Modal';
import { CodeEditorTextArea } from '../components/FormFields/CodeEditor/CodeEditorTextArea';

interface Props {
  code?: string;
  onSave: (code: string) => void;
  open: boolean;
  onClose: () => void;
}

export default function CodeEditorModal({
  code,
  open,
  onClose,
  onSave,
}: Props) {
  const [value, setValue] = useState(code ?? '');

  useEffect(() => {
    setValue(code ?? '');
  }, [code]);

  const actions: ModalActionData[] = useMemo(
    () => [
      {
        title: 'Cancel',
        type: 'secondary',
        onClick: () => onClose(),
      },
      { type: 'spacer' },
      {
        title: 'Save',
        type: 'primary',
        onClick: () => {
          onSave(value);
          onClose();
        },
      },
    ],
    [onClose, onSave, value],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      actions={actions}
      width="6xl"
      actionsAlignment="start"
    >
      {/* <DialogTitle
        as="h3"
        className="text-base font-semibold leading-6 text-gray-900"
      >
        Edit Code
      </DialogTitle> */}
      <div
        className="mt-4 flex flex-col gap-4"
        style={{ height: '60vh', maxHeight: '100%' }}
      >
        <CodeEditorTextArea
          value={value ?? ''}
          onChange={(code) => setValue(code)}
          className="h-full"
        />
      </div>
    </Modal>
  );
}
